//------------------------------------------------------------------------------
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
//------------------------------------------------------------------------------  
enum SubscriptionType {

  /**
   * Monthly auto renewing
   */
  Monthly = 0,

  /**
   * Yearly is the current default while migrating to monthly
   */
  Yearly = 1,

}

export default SubscriptionType;